import {
  baseMethods,
  BooleanResult,
  JsonListResult,
  JsonObjectProperty,
  NumberResult,
  ParseMethod,
  ResultType,
  ResultTypesEnum,
  StringResult,
} from './internal';

export const jsonType: ResultType = {
  name: ResultTypesEnum.JSON,
  properties: {},
  methods: {
    get_json_property: new JsonObjectProperty(),
    as_array: new ParseMethod(JsonListResult),
    as_string: new ParseMethod(StringResult),
    as_number: new ParseMethod(NumberResult),
    as_boolean: new ParseMethod(BooleanResult),
    ...baseMethods,
  },
};
